<template>
  <Card
    class="container"
    :class="{'no-card': noCard}"
  >
    <NdsDlg
      v-if="selectedApplic"
      :isOpen.sync="isNdsDlgOpen"
      :application="selectedApplic"
      @update:isOpen="val => {
        isNdsDlgOpen = val;
        if (!val) selectedApplic = null;
      }"
    />
    <div class="cardTitle">{{ $t('Спецификация') }} {{  byApplication ? '' : '(' + positions.length + ')'}}</div>
    <div
      v-if="showTitleHint && showSubTitleHint && subTitleHint"
      class="cardSubTitle"
    >
      {{ $t(subTitleHint) }}
    </div>
    <div v-if="selectable && selectableCaption" class="cardSubTitle">{{ $t(selectableCaption) }}</div>
    <DataTableVirtual
      :headers="headers"
      :items="poses"
      :no-data-text="tableReplaceCaption"
      disable-sort
      fixed-header
      style="max-height: 580px; overflow-y: auto;"
      class="no-table-border"
      :class="{'grey-quantity': greyStyle}"
      v-model="selected"
      item-value="procedureItemId"
      :show-select="selectable"
    >
      <template v-slot:header.data-table-select="{ allSelected, selectAll, someSelected }">
        <v-checkbox
            :indeterminate="someSelected && !allSelected"
            :model-value="allSelected"
            color="primary"
            @update:model-value="selectAll(!allSelected)"
            class="positionsCheckbox"
            :true-icon="'mdi-check mdi-18px'"
            :indeterminate-icon="'mdi-minus mdi-18px'"
            :false-icon="'voidCheckbox'"
            hide-details
        ></v-checkbox>
      </template>
      <template v-slot:item.data-table-select="{ internalItem, isSelected, toggleSelect }">
        <v-checkbox
            :model-value="isSelected(internalItem)"
            color="primary"
            @update:model-value="toggleSelect(internalItem)"
            class="positionsCheckbox"
            :true-icon="'mdi-check mdi-18px'"
            :indeterminate-icon="'mdi-minus mdi-18px'"
            :false-icon="'voidCheckbox'"
            hide-details
        ></v-checkbox>
      </template>
      <template v-slot:item.name="{ item }">
        <v-textarea
          :class="{'no-chousen': item?.fullQuantity && item?.quantity === null}"
          auto-grow
          variant="plain"
          readonly
          :model-value="item.name"
          :rows="1"
          :max-rows="3"
        />
      </template>
      <template v-slot:item.startMaxPrice="{ item }" v-if="showStartMaxPrice">
        <span>{{ formatStartPrice(item.startMaxPrice) }} $</span>
      </template>
      <template v-slot:item.quantity="{ item }">
        <div v-if="item.quantity" class="quantity-round">
          {{ `${item.quantity} ${item.measure}` }}
        </div>
        <div
          :class="{'through': item?.quantity > 0}"
          v-if="item.fullQuantity && item.fullQuantity !== item.quantity" class="quantity-round no-chousen">
          {{ `${item.fullQuantity} ${item.measure}` }}
        </div>
      </template>
      <template v-slot:item.targetLeadTime="{ item, column }">
        <component
            :is="column.component"
            :position="item"
            :by-application="byApplication"
            :show-price-quantity="showPriceQuantity"
        />
      </template>
      <template v-slot:item.bidPerDay="{ item, column }">
        <component
            :is="column.component"
            :value="item.bidPerDay"
        />
      </template>
      <template v-slot:item.unitPremium="{ item }">
        <span>{{ formatStartPrice(item.unitPremium) }} $</span>
      </template>
      <template v-slot:item.lead="{ internalItem, isSelected, item, column }">
        <component
            v-model="item.lead"
            :is="column.component"
            :is-selected="isSelected(internalItem)"
            :editable="!showPrice"
        />
      </template>
      <template v-slot:item.packagingType="{ internalItem, isSelected, item, column }">
        <component
            v-model="item.packagingType"
            :is="column.component"
            :is-selected="isSelected(internalItem)"
            :editable="!showPrice"
        />
      </template>
      <template v-slot:item.description="{ item }">
        <v-dialog v-if="!!item.description" max-width="500">
          <template v-slot:activator="{ props: activatorProps }">
            <div class="d-flex align-center justify-center" style="width: 100%; height: 100%;">
              <v-icon style="margin: 0px 10px" size="24" v-bind="activatorProps">
                custom:invoice
              </v-icon>
            </div>
          </template>

          <template v-slot:default="{ isActive }">
            <v-card :title="$t('Описание')">
              <template v-slot:append>
                <v-icon icon="mdi-close" @click="isActive.value = false"/>
              </template>
              <v-card-text>
                {{ item.description }}
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
      </template>

      <template v-if="showPrice" v-slot:item.price="{ item, column }">
        <component
          v-if="column.component"
          :is="column.component"
          :value="`${formatStartPrice(calculateCost(item))} $`"
        />
        <span
            v-else
            class="price"
        >
          <div
            :class="{'no-chousen': item?.fullQuantity && item?.quantity === null}"
            class="base-cell">
            {{ formatPrice(calculateCost(item)) }} $
          </div>
        </span>
      </template>
      <template v-if="showSumPrice" v-slot:item.unitPrice="{ item, column }">
        <component
            v-if="column.component"
            :is="column.component"
            :value="`${formatStartPrice(item.unitPrice)} $`"
        />
        <span
            v-else
            class="price"
        >
          <div class="base-cell">
            {{ formatPrice(item.unitPrice) }} $
          </div>
        </span>
      </template>
      <template v-if="byApplication || showPriceQuantity" v-slot:item.sum="{ item }">
        <span
            class="price"
            :style="{ cursor: ndsRate !== null ? 'pointer' : 'default' }"
            @click="ndsRate !== null ? openDialog(item) : null"
        >
          <div v-if="item.sum" class="base-cell">
            {{ formatPrice(calculateCost(item, item.quantity)) }} $
          </div>
          <div
            :class="{'through': item?.quantity > 0}"
            v-if="item.fullQuantity && item.fullQuantity !== item.quantity" class="base-cell no-chousen">
            {{ formatPrice(calculateCost(item, item.fullQuantity)) }} $
          </div>
        </span>
      </template>

    </DataTableVirtual>
  </Card>
</template>

<script>
import {mapStores} from "pinia";
import Card from "@intec/vue-components/form/Card.vue";
import MoneyInput from "@/components/form/MoneyInput.vue";
import { formatPrice, formatStartPrice } from "@/filters";
import {calcPriceNdsByPrice, getIsNdsText} from '@/lib/nds';
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";
import { useApplicationPositionCalculator } from '@/lib/applicationPosition';
import DataTableVirtual from "@intec/vue-components/table/DataTableVirtual.vue"
import { useLibraryStore } from "@/stores/library";
import { usePositionsViewStore } from "@/stores/positionsViewStore";
import validation from "@/components/validation";

export default {
  components: {NdsDlg, MoneyInput, Card, DataTableVirtual},
  name: 'PositionsView',
  props: {
    positions: Array,
    ndsRate: [Number, null],
    partOfVolume: Boolean,
    byApplication: Boolean,
    noCard: {
      type: Boolean,
      default: false
    },
    shortName: {
      type: Boolean,
      default: false
    },
    greyStyle: {
      type: Boolean,
      default: false
    },
    showSubTitleHint: {
      type: Boolean,
      default: true
    },
    procedureType: {
      type: String,
      default: ''
    },
    procedureStep: {
      type: String
    },
    isNds: {
      type: Boolean
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selectableCaption: {
      type: String,
      default: ''
    },
    showStartMaxPrice: {
      type: Boolean,
      default: false,
    },
    showTitleHint: {
      type: Boolean,
      default: true,
    },
    showPriceQuantity: {
      type: Boolean,
      default: false,
    },
    showSumPrice: {
      type: Boolean,
      default: false,
    },
    tableReplaceCaption: {
      type: String,
      default: '',
    },
  },
  data() {
    const { getColumnsHeadersByType } = usePositionsViewStore();

    let selected = [];
    if (this.selectable) {
      this.positions.forEach(function (item) {
        if (item?.selected) {
          selected.push(item.procedureItemId);
        }
      })
    }

    return {
      formatPrice,
      formatStartPrice,
      calcPriceNdsByPrice,
      selectedApplic: {
        'offerPrice': null,
        'nds': {'rate': null},
      },
      isNdsDlgOpen: false,
      selected,
      getColumnsHeadersByType,
      validation,
      showPrice: this.byApplication || (!this.showPriceQuantity && !this.selectable),
    }
  },
  methods: {
    openDialog(position) {
      this.selectedApplic = {
        positions: [
          {
            ...position,
            quantity: position.quantity ?? position.fullQuantity,
          }
        ],
        nds: {
          rate: this.ndsRate
        }
      };
      this.isNdsDlgOpen = true;
    },
    calculateCost(position, quantity) {
      const calculator = useApplicationPositionCalculator(position, this.ndsRate);
      if (!quantity) {
        return calculator.getCostForQuantity(1);
      }
      return this.ndsRate ? calculator.getCostNdsForQuantity(quantity) : calculator.getCostForQuantity(quantity);
    },
  },
  computed: {
    ...mapStores(useLibraryStore),
    headers() {

      let storeHeaders = this.getColumnsHeadersByType(this.procedureType)({
        byApplication: this.byApplication,
        showPriceQuantity: this.showPriceQuantity,
        showPrice: this.showPrice,
        showSumPrice: this.showSumPrice,
      });
      if (storeHeaders.length) {
        return storeHeaders;
      }
      if (this.byApplication || this.showPriceQuantity) {
        const partHeaders = [
          {
            title: 'Наименование',
            key: 'name',
            width: '40%'
          },
          {
            title: 'Кол-во',
            key: 'quantity',
            width: '18%'
          },
          {
            title: this.$t('Цена за единицу {_1}', {'_1': getIsNdsText(this.ndsRate, true)}),
            key: 'price',
            width: '18%'
          },
          {
            title: this.$t('Сумма за позицию {_1}', {'_1': getIsNdsText(this.ndsRate, true)}),
            key: 'sum',
            width: '24%'
          }
        ];

        if (this.shortName) {
          partHeaders.find(h => h.key === 'price').title =
            this.$t('Цена за ед. {_1}', {'_1': getIsNdsText(this.ndsRate, true)});
        }

        return partHeaders;
      }

      const baseHeaders = [
        {
          title: 'Наименование',
          key: 'name',
          width: this.showStartMaxPrice ? '50%' : '80%'
        },
        {
          title: 'Кол-во',
          key: 'quantity',
          width: '15%'
        },
        {
          title: '',
          key: 'description',
          width: '5%'
        }
      ];

      if (this.showStartMaxPrice) {
        const title = 'НМЦ за позицию ' + (this.isNds ? '(с НДС)' : '(без НДС)');

        baseHeaders.splice(1, 0, {
          title: title,
          key: 'price',
          width: '30%'
        });
      }

      return baseHeaders;
    },
    subTitleHint() {
      const flag = this.partOfVolume + (this.byApplication ? 2 : 0);
      switch (flag) {
        case 1: return "Участники вправе предлагать как полный, так и частичный объем по позициям";
        case 2: return "";
        case 3: return "Процедура проводится с возможностью подачи заявок на часть объема позиций";
        default: return "Участники могут подавать предложения только на полный объем каждой позиции (выборочно или по всем)";
      }
    },
    poses() {
      return this.tableReplaceCaption ? [] : this.positions;
    }
  },
  mounted() {
    if (this.byApplication) this.positions.map(pos => {
      pos.sum = pos.price * pos.quantity;
    });
  }
}
</script>

<style scoped>
:deep(.v-data-table) {
  th {
    background-color: #F6F6F6 !important;
    .v-data-table-header__content {
      font-size: 16px;
      color: #000000 !important;
    }
  }
  [data-required] {
    span::after {
      content: ' *';
      color: rgba(var(--error-color));
    }
  }
  .v-table__wrapper > table > tbody > tr > td {
    padding: 0 5px;
  }
}

.no-table-border {
  border: none;
  border-radius: 0;
}

.base-cell {
  font-size: 16px;
  font-weight: 500;
  padding: 0 11px;
}

.quantity-round {
  border-radius: 8px;
  background-color: rgb(var(--quantity-round));
  padding: 5px;
  display: flex;
  justify-content: center;
}
.quantity-round:not(:last-child) {
  margin-bottom: 2px;
}
.no-chousen:not(.quantity-round) {
  color: rgb(var(--grey-2)) !important;
}
.no-chousen.quantity-round {
  background-color: rgb(var(--grey-4)) !important;
}
.through {
  text-decoration: line-through;
}
.grey-quantity {
  :not(.no-chousen).quantity-round {
    color: rgb(var(--blue-1));
  }
}
.grey-quantity {
  .no-chousen.quantity-round {
    color: rgb(var(--grey-2));
  }
}
.no-card {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

:deep(.v-data-table-rows-no-data) {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: rgb(var(--unactive-text-color));
}

:deep(.v-input--density-default) {
  --v-input-control-height: auto;
}
:deep(.v-selection-control--density-default) {
  --v-selection-control-size: 30px;
}
:deep(.positionsCheckbox .v-label) {
  color: rgb(var(--black-color));
  font-family: var(--primary-font-family-name);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  opacity: 1;
  padding-left: 13px;
}
:deep(.mdi-check.mdi-18px) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  opacity: 1;
  color: rgb(var(--intec-primary-color));
}
:deep(.mdi-minus.mdi-18px) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  opacity: 1;
  color: rgb(var(--intec-primary-color));
}
:deep(.voidCheckbox) {
  border-radius: 3px;
  border: 1px solid rgba(var(--black-color), 0.3);
  opacity: 1;
}
:deep(.v-data-table-rows-no-data) {
  text-align: start;
  font-family: 'Manrope';
  font-weight: 400;
  font-size: 16px;
  color: rgb(var(--grey-1));
}
</style>
